import styled from 'styled-components';

export const PostContainer = styled.div``;

export const PostContainerClone = styled(PostContainer)`
  opacity: 0.5;
  transform: none !important;
`;
